/* eslint-disable  @typescript-eslint/no-explicit-any */
import { Alert, AlertColor, Snackbar } from "@mui/material";
import { AppContext } from "../../utils/AppContext";
import * as React from "react";
import { useEffect, useState } from "react";
import { useCustomerSupportService } from "../../services/backend/CustomerSupportService";
import { LoadingOverlay } from "../../components/LoadingOverlay";
import { ILiveDataOperation, LiveOperationsTable } from "./LiveOperationsTable";

const LiveOperations = () => {
  const customerSupportService = useCustomerSupportService();

  const [alertMessage, setAlertMessage] = useState<string | undefined>(undefined);
  const [alertSeverity, setAlertSeverity] = useState<AlertColor>("info");
  const [rows, setRows] = useState<ILiveDataOperation[]>([]);
  const [loading, setLoading] = useState(false);
  const [environment, setEnvironment] = useState<string>("");

  const fetchRows = async () => {
    if (!environment) {
      return;
    }
    try {
      const response = await customerSupportService.listLiveOperationsByEnvironment(environment);
      const messages = Array.isArray(response) ? response : response.messages || [];
      setRows(messages);
    } catch (e: any) {
      setAlertMessage(e.debugMessage || "Could not fetch the list of live operations.");
      setAlertSeverity("error");
    }
  };

  const refreshButtonClickHandler = async () => {
    setLoading(true);
    await fetchRows();
    setLoading(false);
  };

  const alertCloseHandler = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertMessage(undefined);
  };

  const context = React.useContext(AppContext);
  useEffect(() => {
    if (context) {
      context.setTitle("Live Operations");
      context.setTargetAPI("environment");
      if (context.selectedEnvironment) {
        const envName = context.selectedEnvironment.name;
        setEnvironment(envName);
        (async () => {
          setLoading(true);
          try {
            const response = await customerSupportService.listLiveOperationsByEnvironment(envName);
            const messages = Array.isArray(response) ? response : response.messages || [];
            setRows(messages);
          } catch (e: any) {
            setAlertMessage(e.debugMessage || "Could not fetch the list of live operations.");
            setAlertSeverity("error");
          } finally {
            setLoading(false);
          }
        })();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context]);

  return (
    <>
      <LiveOperationsTable rows={rows} environment={environment} onRefreshButtonClick={refreshButtonClickHandler} />
      <Snackbar open={alertMessage !== undefined} autoHideDuration={5000} onClose={alertCloseHandler}>
        <Alert onClose={alertCloseHandler} severity={alertSeverity} sx={{ width: "100%" }}>
          {alertMessage}
        </Alert>
      </Snackbar>
      {loading && <LoadingOverlay />}
    </>
  );
};

export default LiveOperations;
